module.exports = __webpack_public_path__ + "static/media/flowchart.f3bb97c2.png";